import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const chartSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 31.9256L20.2056 21.777L26.3813 27.6059L37.75 16.25M37.75 16.25C37.75 16.25 37.5 16 37 16C36.5 16 30.1495 16 30.1495 16M37.75 16.25C37.75 16.25 38 16.5 38 17C38 17.5 38 24.0149 38 24.0149"
            stroke="currentColor"
        />
    </svg>
)

const chartSvgSmall = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.84906 11.24L7.54717 7.32L10.4528 10.4L15.8679 4.66M15.8679 4.66C15.8679 4.66 16 4.66 16 5.36V8.44M15.8679 4.66C15.8679 4.66 15.8679 4.52 15.2075 4.52H12.3019M2 2V16H15.2075"
            stroke="currentColor"
            strokeLinecap="round"
        />
    </svg>
)

const Chart: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{props.fontSize === 'small' ? chartSvgSmall : chartSvg}</SvgIcon>

export default Chart
